import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "text-body-1" }
const _hoisted_2 = { class: "text-body-1" }
const _hoisted_3 = { style: {"justify-items":"center"} }
const _hoisted_4 = { class: "text-left" }
const _hoisted_5 = { class: "text-left" }
const _hoisted_6 = {
  key: 0,
  class: "mt-1 text-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn_primary = _resolveComponent("v-btn-primary")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_select_filled = _resolveComponent("v-select-filled")!
  const _component_AccountableAccountFilter = _resolveComponent("AccountableAccountFilter")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_AccountableAccountEdition = _resolveComponent("AccountableAccountEdition")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_card, {
      class: "default_card_wm",
      elevation: "0"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_row, {
          "no-gutters": "",
          class: "d-flex py-3 justify-center"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, {
              cols: "2",
              class: "pr-2"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn_primary, {
                  dark: "",
                  block: "",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.editAccountableAccount(''))),
                  disabled: _ctx.readonly
                }, {
                  default: _withCtx(() => _cache[13] || (_cache[13] = [
                    _createTextVNode(" Nouveau ")
                  ])),
                  _: 1
                }, 8, ["disabled"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, { cols: "2" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_text_field_filled, {
                  modelValue: _ctx.accountingPlanName,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.accountingPlanName) = $event)),
                  label: "Nom du plan comptable",
                  "hide-details": "",
                  outlined: "",
                  density: "compact",
                  class: "px-1",
                  disabled: _ctx.readonly
                }, null, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, {
              cols: "2",
              class: "px-2"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_select_filled, {
                  modelValue: _ctx.aaCharacterCount,
                  "onUpdate:modelValue": [
                    _cache[2] || (_cache[2] = ($event: any) => ((_ctx.aaCharacterCount) = $event)),
                    _ctx.updateAANames
                  ],
                  items: [6, 7, 8, 9, 10, 11, 12],
                  label: "Nombre de caractères",
                  outlined: "",
                  density: "compact",
                  "hide-details": "",
                  disabled: _ctx.id.length > 0
                }, null, 8, ["modelValue", "disabled", "onUpdate:modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, {
              cols: "3",
              class: "pl-2"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_AccountableAccountFilter, {
                  search: _ctx.search,
                  "onUpdate:search": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.search) = $event)),
                  thirdParty: _ctx.tiersSearch,
                  "onUpdate:thirdParty": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.tiersSearch) = $event)),
                  vatType: _ctx.vatTypeSearch,
                  "onUpdate:vatType": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.vatTypeSearch) = $event)),
                  vatOperation: _ctx.vatOperationSearch,
                  "onUpdate:vatOperation": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.vatOperationSearch) = $event)),
                  transactionType: _ctx.transactionTypeSearch,
                  "onUpdate:transactionType": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.transactionTypeSearch) = $event)),
                  lettering: _ctx.showLettering,
                  "onUpdate:lettering": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.showLettering) = $event)),
                  publish: _ctx.showPublished,
                  "onUpdate:publish": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.showPublished) = $event)),
                  default: _ctx.showDefault,
                  "onUpdate:default": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.showDefault) = $event)),
                  onUpdatedFilter: _ctx.reRenderTable
                }, null, 8, ["search", "thirdParty", "vatType", "vatOperation", "transactionType", "lettering", "publish", "default", "onUpdatedFilter"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, {
              cols: "3",
              class: "d-flex justify-center align-center flex-column"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_switch, {
                  modelValue: _ctx.showSelected,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.showSelected) = $event)),
                  label: "Afficher la sélection",
                  "hide-details": "",
                  class: "mt-0"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_row, {
          "no-gutters": "",
          class: "py-2"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { cols: "12" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, { class: "d-flex justify-center" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { cols: "11" }, {
                      default: _withCtx(() => [
                        (_openBlock(), _createBlock(_component_v_data_table, {
                          key: _ctx.tableKey,
                          headers: _ctx.plantHeaders,
                          items: _ctx.accountingTable,
                          "fixed-header": true,
                          "custom-filter": _ctx.descriptionFilter,
                          class: "table elevation-0",
                          "group-by": [{ key: 'digit', order: 'asc' }],
                          "items-per-page": -1,
                          "hide-default-footer": "",
                          style: {"max-height":"calc(100vh - 350px)","overflow-y":"auto"}
                        }, {
                          "group-header": _withCtx(({
                                        item,
                                        columns,
                                        isGroupOpen,
                                        toggleGroup,
                                        index,
                                    }) => [
                            (_openBlock(), _createElementBlock("tr", {
                              key: `group_${item.value}`
                            }, [
                              _createElementVNode("td", null, [
                                _createVNode(_component_v_btn_icon, {
                                  ref: `toggle_btn_${item.value}`,
                                  onClick: ($event: any) => {
                                                    toggleGroup(item);
                                                    _ctx.expandedGroups[parseInt(item.value) - 1] =
                                                        isGroupOpen(item);
                                                },
                                  icon: 
                                                    isGroupOpen(item)
                                                        ? '$fa-chevron-up'
                                                        : '$fa-chevron-down'
                                                ,
                                  size: "medium",
                                  class: "ml-1"
                                }, null, 8, ["onClick", "icon"])
                              ]),
                              _createElementVNode("td", null, [
                                _createVNode(_component_v_btn_icon, {
                                  onClick: ($event: any) => (_ctx.toggleSelectGroup(item.value)),
                                  "hide-details": "",
                                  icon: _ctx.getGroupState(item.value),
                                  color: "primary",
                                  disabled: _ctx.readonly
                                }, null, 8, ["onClick", "icon", "disabled"])
                              ]),
                              _createElementVNode("td", null, [
                                _createElementVNode("span", _hoisted_1, _toDisplayString(item.value), 1),
                                _createVNode(_component_v_icon, {
                                  icon: _ctx.selectIcon(item.value.toString()),
                                  color: "green",
                                  class: "ml-3",
                                  size: "large"
                                }, null, 8, ["icon"])
                              ]),
                              _createElementVNode("td", null, [
                                _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t(
                                                        "accountableAccount." +
                                                            _ctx.getAccountableAccountType(item.value),
                                                    )), 1)
                              ]),
                              _cache[14] || (_cache[14] = _createElementVNode("td", null, null, -1)),
                              _cache[15] || (_cache[15] = _createElementVNode("td", null, null, -1)),
                              _cache[16] || (_cache[16] = _createElementVNode("td", null, null, -1))
                            ]))
                          ]),
                          "header.data-table-group": _withCtx(() => [
                            _createVNode(_component_v_tooltip, { location: "bottom" }, {
                              activator: _withCtx(({ props }) => [
                                _createVNode(_component_v_btn_icon, _mergeProps(props, {
                                  icon: 
                                                    _ctx.toggleOpenAll
                                                        ? '$fa-caret-down'
                                                        : '$fa-caret-up'
                                                ,
                                  onClick: _ctx.openAllTable,
                                  color: "secondary",
                                  density: "compact",
                                  disabled: _ctx.disableOpenAll
                                }), null, 16, ["icon", "onClick", "disabled"])
                              ]),
                              default: _withCtx(() => [
                                _createElementVNode("span", null, _toDisplayString(_ctx.toggleOpenAll
                                                ? "Ouvrir les groupes"
                                                : "Fermer les groupes"), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          item: _withCtx((props) => [
                            _createElementVNode("tr", null, [
                              _cache[17] || (_cache[17] = _createElementVNode("td", null, null, -1)),
                              _createElementVNode("td", _hoisted_3, [
                                _createVNode(_component_v_checkbox, {
                                  color: "primary",
                                  density: "compact",
                                  small: "",
                                  disabled: props.item.disabled,
                                  "hide-details": "auto",
                                  onClick: ($event: any) => (_ctx.handleRowClick($event, props.item)),
                                  "onUpdate:modelValue": ($event: any) => (_ctx.updateSelected(props.item)),
                                  readonly: _ctx.readonly,
                                  "model-value": _ctx.selected.includes(props.item.name)
                                }, null, 8, ["disabled", "onClick", "onUpdate:modelValue", "readonly", "model-value"])
                              ]),
                              _createElementVNode("td", null, _toDisplayString(props.item.name), 1),
                              _createElementVNode("td", _hoisted_4, _toDisplayString(props.item.description), 1),
                              _createElementVNode("td", _hoisted_5, [
                                (
                                                    !props.item.children.length && props.item.isLeaf //&&
                                                    // !props.item.name.startsWith('6') &&
                                                    // !props.item.name.startsWith('7')
                                                )
                                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.complementInfo(
                                                        props.item,
                                                        false,
                                                    ), (info) => {
                                      return (_openBlock(), _createBlock(_component_v_chip, {
                                        key: props.item.name + '-' + info,
                                        label: "",
                                        class: "ma-1",
                                        size: "x-small"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(info), 1)
                                        ]),
                                        _: 2
                                      }, 1024))
                                    }), 128))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("td", null, [
                                (
                                                    !props.item.children.length && props.item.isLeaf //&&
                                                    // !props.item.name.startsWith('6') &&
                                                    // !props.item.name.startsWith('7')
                                                )
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(props.item.lettering ? "À lettrer" : ""), 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("td", null, [
                                (_ctx.isEditableLeaf(props.item))
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      (!_ctx.readonly)
                                        ? (_openBlock(), _createBlock(_component_v_btn_icon, {
                                            key: 0,
                                            icon: "$oss-edit",
                                            size: "small",
                                            disabled: !_ctx.selected.includes(props.item.name),
                                            onClick: ($event: any) => (_ctx.editAccountableAccount(props.item.name))
                                          }, null, 8, ["disabled", "onClick"]))
                                        : _createCommentVNode("", true)
                                    ], 64))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ]),
                          _: 1
                        }, 8, ["headers", "items", "custom-filter"]))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (_ctx.editAccountDialog)
      ? (_openBlock(), _createBlock(_component_AccountableAccountEdition, {
          key: 0,
          modelValue: _ctx.editAccountDialog,
          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.editAccountDialog) = $event)),
          accountableAccount: _ctx.accountableAccountEdition,
          existingAccountableAccounts: _ctx.allLeaves,
          authorizeExistingAAModification: true,
          aaCharacterCount: _ctx.aaCharacterCount,
          fromParentTable: true,
          onValidate: _ctx.upsertPattern
        }, null, 8, ["modelValue", "accountableAccount", "existingAccountableAccounts", "aaCharacterCount", "onValidate"]))
      : _createCommentVNode("", true)
  ]))
}